<template>
  <div class="">
    <b-card v-show="shownewpage">
      <div>
        <div class="mb-4">
          <base-button
            icon
            type=""
            class="bg-f4f5f6 custpad5-10"
            v-if="shownewpage"
            @click="shownewpage = false"
          >
            <span class="btn-inner--icon"><i class="ni ni-bold-left"></i></span>

            <span class="btn-inner--text">Back</span>
          </base-button>
        </div>
        <AddCourse :toggleCourse="toggleCourse" :shownewpage="shownewpage" />
      </div>
    </b-card>
    <b-card v-if="!shownewpage">
      <modal :show.sync="editModal" header-classes="bg-primary p-3">
        <h6 slot="header" class="modal-title text-white font-semibold pt-1">
          EDIT IMAGE ORDER
        </h6>
        <AddPageDetail />

        <template slot="footer">
          <base-button type="primary">SAVE CHANGES</base-button>
          <base-button
            type="secondary"
            class="ml-auto"
            @click="editModal = false"
            >CLOSE</base-button
          >
        </template>
      </modal>

      <modal
        :show.sync="asset"
        scrollable
        size=""
        header-classes="bg-primary p-3"
        body-classes="overflow-y-auto h65vh"
      >
        <h6 slot="header" class="modal-title text-white font-semibold pt-1">
          ASSESSMENT
        </h6>
        <!-- <AddPageDetail /> -->
        <Assesment />
        <template slot="footer">
          <base-button type="primary">SAVE</base-button>
          <base-button type="secondary" class="ml-auto" @click="asset = false"
            >CLOSE</base-button
          >
        </template>
      </modal>

      <div class="flex justify-between items-center">
        <div>
          <h2 class="text-2xl font-semibold">Course</h2>
        </div>
        <!-- @click="asset = true"  -->
        <base-button
          outline
          type="primary"
          class="flex px-6 py-1 mx-1"
          @click="shownewpage = true"
        >
          <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Add Course
        </base-button>
      </div>
      <b-input-group class="mt-12">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          v-model="search"
          placeholder="Enter Search...."
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>

      <!-- status -->
      <!-- <div class="flex items-center pt-8">
        <div class="status mr-2">
          <p class="font-semibold text-base">Status</p>
        </div>
        <div>
          <button
            type="button"
            class="btn btn-outline-primary cust-btnsm radius20"
            v-for="(filter, index) in filters"
            :key="'filter-btn-' + index"
          >
            {{ filter.text }}
          </button>
        </div>
      </div> -->
      <template v-if="course.result.length !== 0">
        <coursecard />
      </template>
      <template v-else>
        <div class="flex items-center pt-8">No Data</div>
      </template>

      <b-card-footer
        class="py-4 d-flex lg:justify-end md:justify-end justify-center"
      >
        <base-pagination
          v-model="currentPage"
          :per-page="10"
          :total="course.totalCount"
          @change="handlePageChange"
        ></base-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>
<script>
import Data from "./components/Data";
import AddPageDetail from "./components/AddPageDetail";
import AddCourse from "./components/AddCourse.vue";
import coursecard from "./components/coursecard.vue";
import Assesment from "./components/Assesment.vue";
import { mapState } from "vuex";

export default {
  components: {
    AddPageDetail,
    AddCourse,
    coursecard,
    Assesment,
  },
  data() {
    return {
      Data,
      currentPage: 1,
      search: "",
      editModal: false,
      asset: false,
      shownewpage: false,
      filters: [
        // { text: "Not Contacted", type: "filter-changed" },
        { text: "All Draft (2)", type: "schedule" },
        { text: "Pending (6)", type: "overdue" },
        { text: "Review (0)", type: "added-today" },
        { text: "Corrections (4)", type: "added-today" },
        { text: "Published (6)", type: "added-today" },
        { text: "Unpublished (3)", type: "added-today" },
      ],
    };
  },
  computed: {
    ...mapState("eLearning", ["course"]),
    ...mapState("auth", ["userData"]),
    ...mapState("author", ["authorData"]),
  },
  watch: {
    search: {
      handler: _.debounce(async function (val) {
        this.getCourses();
      }, 500),
    },
  },
  methods: {
    async getCourses() {
      if (this.userData.role == "author") {
        await this.$store.dispatch("author/getAuthorByUserId", {
          userId: this.userData._id,
          search: this.search,
        });
      } else {
        // if (this.search.trim() == "") {
        //   let payload = {
        //     limit: 10,
        //     offset: (this.currentPage - 1) * 10,
        //     isAdmin: true,
        //   };
        //   await this.$store.dispatch("eLearning/getCourses", payload);
        // } else {
        let payload = {
          limit: 10,
          offset: (this.currentPage - 1) * 10,
          isAdmin: true,
          search: this.search.trim(),
        };
        await this.$store.dispatch("eLearning/getCourses", payload);
        // }
      }
      // console.log(this.authorData);
    },
    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    },
    toggleCourse() {
      this.shownewpage = false;
    },
    async handlePageChange(page) {
      this.currentPage = page;

      let payload = {
        limit: 10,
        offset: (page - 1) * 10,
        isAdmin: true,
      };
      // console.log(payload);
      await this.$store.dispatch("eLearning/getCourses", payload);
    },
  },
  mounted() {
    this.getCourses();
  },
};
</script>
